'use es6';

import { List, Record } from 'immutable';
import { ContentTypes } from '../constants/ContentConstants';
export default Record({
  completed: false,
  contents: undefined,
  contentType: ContentTypes.CHAPTER,
  contentError: undefined,
  description: undefined,
  graded: false,
  hubId: null,
  id: undefined,
  isLoadingContents: false,
  language: undefined,
  name: undefined,
  professors: List(),
  readingTimeMinutes: undefined
}, 'Chapter');